import { render, staticRenderFns } from "./PalatsOrderDetails.vue?vue&type=template&id=1fd4b694&scoped=true"
import script from "./PalatsOrderDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./PalatsOrderDetails.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PalatsOrderDetails.vue?vue&type=style&index=0&id=1fd4b694&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd4b694",
  null
  
)

export default component.exports